import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.$placeholder = this.$('placeholder')[0];
        this.$iframe = this.$('iframe')[0];
        this.$id = this.$iframe.id;

        this.events = {
            click: {
                'placeholder': 'playVideo'
            }
        }
    }

    playVideo() {
        setTimeout(() => {
            this.$placeholder.classList.add('is-hidden');
        }, 500)
        this.$iframe.src = `https://www.youtube.com/embed/${this.$id}?rel=0&modestbranding=1&autoplay=1&autohide=1&showinfo=0&controls=1`
    }
}